import axios from 'axios';

export default function Comments() {
  const Comment = {
    displayMessage: (message, type = 'success') => {
      const commentMessage = document.getElementById('comment-top-message');
      if (!commentMessage) return;

      if (message) {
        commentMessage.innerHTML = '';
      }

      // scroll to alert message
      commentMessage.scrollIntoView();
      // add style
      commentMessage.classList.remove('hidden');
      commentMessage.classList.add('mb-4');

      if (type !== 'success') {
        commentMessage.classList.add('alert--danger');
        commentMessage.classList.remove('alert--success');
      } else {
        commentMessage.classList.add('alert--success');
        commentMessage.classList.remove('alert--danger');
      }

      // add message
      message.forEach((message) => {
        const messageElement = document.createElement('p');
        messageElement.innerText = message;
        commentMessage.append(messageElement);
      });
    },
    abuseComment: async (event) => {
      event.preventDefault();

      const form = event.currentTarget.parentElement;

      const response = await axios({
        method: 'POST',
        data: new FormData(form),
        url: form.action
      });

      if (response.data.success) {
        // display message
        Comment.displayMessage([response.data.message]);
        // remove comment
        document.getElementById(event.target.dataset.commentId).remove();
      } else {
        // display error
        Comment.displayMessage([response.data.error], 'error');
      }
    },
    deleteComment: async ({ currentTarget }) => {
      // delete it
      const response = await axios({
        method: 'GET',
        url: window.commentConfig.delete + '/' + currentTarget.dataset.id
      });

      if (response.data.success) {
        Comment.displayMessage([response.data.message]);

        const commentToRemove = document.getElementById(
          `comment-${currentTarget.dataset.id}`
        );

        const body = document.querySelector('body');
        const modalActivated = document.querySelector('.Modal.active');

        if (modalActivated) {
          modalActivated.classList.remove('active');
          body.classList.remove('Modal-active');
        }

        if (commentToRemove) {
          commentToRemove.remove();
        }
      } else {
        Comment.displayMessage([response.data.error], 'error');
      }
    },
    loadNextComment: async (event) => {
      event.preventDefault();

      const { currentTarget } = event;

      // appel sur la page courante
      const { data } = await axios({
        method: 'GET',
        url: currentTarget.href
      });

      const parser = new DOMParser();

      const html = parser.parseFromString(data, 'text/html');

      // récupérer le bloc des commentaires
      const commentList = html.getElementById('comment-list');

      // remplacer le bloc des commentaire par celui de l'ajax
      document.getElementById('comment-list').replaceWith(commentList);
      const commentsTitle = document.querySelector('.comments-title');

      if (commentsTitle) {
        commentsTitle.scrollIntoView();
      }

      // ajout dans l'uri de la page = nbPage.
      global.history.replaceState({}, 'produit', `${currentTarget.href}`);

      // relancer un listener
      const paginations = document.querySelectorAll('[data-next-page]');

      paginations.forEach((pagination) =>
        pagination.addEventListener('click', Comment.loadNextComment)
      );
    }
  };

  const commentForm = document.getElementById('form-add-comment');
  const deletesButton = document.querySelectorAll('.delete-trigger');
  const abusesButton = document.querySelectorAll('.abuse-trigger');

  deletesButton.forEach((deleteButton) =>
    deleteButton.addEventListener('click', Comment.deleteComment)
  );

  abusesButton.forEach((abuseButton) =>
    abuseButton.addEventListener('click', Comment.abuseComment)
  );

  if (!commentForm) return;

  const inputs = commentForm.querySelectorAll('input');

  [...inputs].forEach((input) => {
    input.addEventListener('focus', () => {
      if (document.getElementById('SciptRecaptcha')) return null;

      const scriptTag = document.createElement('script');
      scriptTag.setAttribute('src', window.SCRIPTRECAPTCHA);
      scriptTag.setAttribute('id', 'SciptRecaptcha');
      commentForm.appendChild(scriptTag);
    });
  });

  commentForm.addEventListener('validRecaptcha', async (event) => {
    event.preventDefault();
    const formData = new FormData(commentForm);
    formData.append('g-recaptcha-response', event.detail.token);
    commentForm.classList.add('is-loading');

    const response = await axios({
      method: 'POST',
      data: formData,
      url: event.currentTarget.action
    });

    if (response.data.success) {
      // display message
      Comment.displayMessage(response.data.messages);
      // remove form
      commentForm.classList.add('hidden');
    } else {
      Comment.displayMessage(response.data.messages, 'error');
    }
    commentForm.classList.remove('is-loading');
  });

  const paginations = document.querySelectorAll('[data-next-page]');

  paginations.forEach((pagination) =>
    pagination.addEventListener('click', Comment.loadNextComment)
  );
}
